/**
 * 구독 결제 내역 조회 훅
 * FSD: features/subscription/subscription-manage/hooks
 */

import { useQuery } from '@tanstack/react-query';
import { subscriptionAPI } from '../api/subscription-api';

export const useBillingHistory = (subscriptionId: string | undefined) => {
  return useQuery({
    queryKey: ['billing-history', subscriptionId],
    queryFn: () => {
      if (!subscriptionId) throw new Error('구독 ID가 필요합니다');
      return subscriptionAPI.getSubscriptionBillingHistory(subscriptionId);
    },
    enabled: !!subscriptionId,
    staleTime: 5 * 60 * 1000, // 5분
  });
};
